import React from 'react';
import { connect } from 'react-redux';

// import LogRocket from 'logrocket';
import mixpanel from '../../utils/mixpanel';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

import session from '../../utils/session';

import resources from '../../reducers/login/resources';
import { checkIfUserIsNew } from '../../reducers/user/resources';

import RedirectComponent from '../common/redirect';

import { initRoom } from '../../io';
import config from '../../config';
import constants from '../../constants';

import CountdownButton from '../settings/countdown';
import './index.css';

class Login extends React.Component {
	componentWillMount() {
		this.setState({
			username: '',
			password: '',
			error: '',
			show2faForm: false,
			code: '',
			requestId: '',
			tfaLoading: false,
			resetTfaTimer: false
		});

		const requestId = session.get('login_tfa_req_id')
		
		if(requestId) {
			this.setState({
				requestId,
				show2faForm: true
			})
		}
	}

	handleOnChange = key => {
		return e => {
			let state = JSON.parse(JSON.stringify(this.state));

			state[key] = e.target.value;

			this.setState(state);
		};
	};

	processLogin = () => {
		const user = session.get('tempUser');
		const self = this;

		const fromEmailParam = session.getURLParam('fromemail')
		const routeParam = session.getURLParam('route')
		const isAdmin = user.role == config.ghAdminRole

		session.set('token', user.token);
		session.set('userBots', user.bots);
		session.set('userData', user);
		// Stash family profiles for multi-brand notification session-swapping.
		session.set('allProfiles', user.allProfiles || [user]);

		// if (process.env.NODE_ENV === 'production') {
		// 	// identify logrocket session
		// 	LogRocket.identify(user.id, {
		// 		name: user.name,
		// 		email: user.email,
		// 		username: user.username
		// 	});
		// }

		this.props.initRoom(user.id);

		(async () => {
			session.unset('tempUser')

			const user = await checkIfUserIsNew();
			const { new_user: newUser } = user.data;

			if (newUser) {
				mixpanel.track('auth:signin new user');

				return self.props.history.replace({ pathname: '/account-setup' });
			}

			mixpanel.track('auth:login', { source: "webapp" });

			if(!isAdmin && fromEmailParam) {
				return self.props.history.replace({ pathname: `/${routeParam}` });
			}
				
			self.props.history.replace({ pathname: '/inbox' });
		})();
	}

	handleVerificationCheck = e => {
		e.preventDefault();
		const { code, requestId } = this.state;

		this.setState({ tfaLoading: true, error: '' })

		if (!code) {
			return this.setState({
				error: 'Please enter verification code.'
			});
		}

		const catchStates = () => {
			this.setState({
				show2faForm: false,
				tfaLoading: false,
				error: constants.tfa.check.checkFailed
			});
			session.unset('login_tfa_req_id')
		}

		resources.checkVerification({ requestId: requestId, code })
			.then(res => {
				if(res.data.status === '0') {
					this.processLogin();
					this.setState({
						code: '',
						requestId: '',
						tfaLoading: false,
						show2faForm: false,
						error: ''
					});
					session.unset('login_tfa_req_id')
				} else if(res.data.status === '16') {
					this.setState({
						tfaLoading: false,
						error: constants.tfa.check.notMatch
					});
				} else {
					catchStates()
				}
			})
			.catch(() => {
				catchStates()
			})
	}

	handleCancelVerification = () => {
		const { requestId } = this.state

		this.setState({ tfaLoading: true, error: '' })

		const clearStates = () => {
			this.setState({
				code: '',
				requestId: '',
				show2faForm: false,
				tfaLoading: false
			});
		}

		const clearSessions = () => {
			session.unset('login_tfa_req_id')
			session.unset('tempUser')
		}

		resources.cancelVerification({ requestId })
			.then(res => {

				if(res.data.status === '0') {
					clearStates();
					this.setState({ error: '' });

					clearSessions();
				} else if(res.data.status === '19') {
					this.setState({
						tfaLoading: false,
						error: constants.tfa.cancellation.noEarlyCancel
					});
				} else if(res.data.status === '6') {
					clearStates();

					this.setState({
						error: constants.tfa.cancellation.expiredRequest
					});

					clearSessions();
				} else {
					clearStates();

					this.setState({
						error: constants.tfa.cancellation.cancelFailed
					});
					
					clearSessions();
				}
			}).catch(err => {
				clearStates();
				this.setState({
					error: constants.tfa.cancellation.cancelFailed
				});
				
				clearSessions();
			})
	}

	handleSignIn = ev => {
		ev.preventDefault();

		this.setState({ error: '' })

		if (!this.state.username) {
			return this.setState({
				error: 'Please enter username.'
			});
		}

		if (!this.state.password) {
			return this.setState({
				error: 'Please enter password.'
			});
		}

		resources
			.authenticate({
				username: this.state.username,
				password: this.state.password,
				source: 'web',
			})
			.then(res => {
				const user = res.data;

				// set temp user for initial use
				session.set('tempUser', user);

				if(user.tfa_option) {
				
					if (!user.userMobile) {
						return this.setState({
							error: 'User has no mobile number.'
						});
					}

					resources.requestVerification({ userNumber: user.userMobile })
						.then(res => {
							session.set('login_tfa_req_id', res.data)
							this.setState({
								requestId: res.data,
								show2faForm: true
							})
						})
						.catch(() => {
							session.unset('login_tfa_req_id');
							session.unset('tempUser');
							this.setState({
								error: constants.tfa.request.requestFailed
							});
						})

				} else {
					this.processLogin();
				}
			})
			.catch(error => {
				this.setState({
					error: error.message
				});
			});
	};

	gotoRegister = () => this.props.history.push('/register');

	gotoForgotPassword = event => {
		event.preventDefault();
		this.props.history.push('/forgot-password');
	};

	handleResendVerification = () => {
		const { requestId } = this.state

		this.setState({ tfaLoading: true, error: '' })

		const handleClear = () => {
			this.setState({
				tfacode: '',
				requestId: '',
				show2faForm: false,
				tfaLoading: false,
			});
			session.unset('login_tfa_req_id')
		}

		// cancel the current requet
		resources.cancelVerification({ requestId: requestId })
			.then(res => {
				if(res.data.status === '0') {
					this.setState({
						tfacode: '',
						requestId: '',
					});
					session.unset('login_tfa_req_id')

					// request new verification
					const tempUser = session.get('tempUser')
					resources.requestVerification({ userNumber: tempUser.userMobile })
						.then(res => {
							session.set('login_tfa_req_id', res.data)

							this.setState({
								requestId: res.data,
								tfaLoading: false,
								resetTfaTimer: true
							})
						})
						.catch(() => {
							this.setState({
								tfaLoading: false,
								show2faForm: false,
								error: constants.tfa.request.requestFailed
							});
							session.unset('tempUser')
						})
				} else if(res.data.status === '19') {
					this.setState({
						tfaLoading: false,
						error: constants.tfa.cancellation.noEarlyCancel
					});
				} else if(res.data.status === '6') {
					handleClear()
					this.setState({
						error: constants.tfa.cancellation.expiredRequest
					});
				} else {
					handleClear()
					this.setState({
						error: constants.tfa.resend.resendFailed
					});
				}
			}).catch(() => {
				handleClear()
				this.setState({
					error: constants.tfa.resend.resendFailed
				});
			})
	}
	
	getResetTfaButton = () => {
		const requestId = session.get('login_tfa_req_id')
		if(this.state.requestId || requestId) {
			return (
				<CountdownButton
					handleResend={this.handleResendVerification}
					resetTfaTimer={this.state.resetTfaTimer}
					handleReset={() => this.setState({ resetTfaTimer: false })}
				/>
			)
		}
	}

	render() {
		const styles = {
			forgotPassword: {
				color: '#48b54b',
				float: 'right'
			}
		};

		const renderScreen = () => {
			/* Check if webpage being accessed is gohire beta */
			if(window.location.href.includes('beta.gohire.com')) {
				return <RedirectComponent/>;
			} else if (this.state.show2faForm) {
				return (
					<form id="handleVerificationCheck" onSubmit={this.handleVerificationCheck}>
						<h4>Enter the verification code sent to your mobile number.</h4>
						<input type="hidden" autoComplete="off"/>
						<TextField
							type="text"
							hintText="Verification code"
							fullWidth={true}
							autoComplete="off"
							onChange={this.handleOnChange('code')}
						/>
						<span style={{ color: 'red' }}>{this.state.error}</span>
						<RaisedButton
							type="submit"
							className="sign-in-btn"
							label="Sign In"
							primary={true}
							fullWidth={true}
							disabled={this.state.tfaLoading || !this.state.code}
						/>
						<FlatButton
							label="Cancel"
							primary={true}
							onClick={this.handleCancelVerification}
						/>
						{this.getResetTfaButton()}
					</form>
				)
			} else {
				return (
					<form id="handleSignIn" onSubmit={this.handleSignIn}>
						<TextField
							type="text"
							hintText="User name"
							fullWidth={true}
							autoFocus={true}
							onChange={this.handleOnChange('username')}
						/>
						<TextField
							type="password"
							hintText="Password"
							fullWidth={true}
							onChange={this.handleOnChange('password')}
						/>
						<span style={{ color: 'red' }}>{this.state.error}</span>
						<RaisedButton
							type="submit"
							className="sign-in-btn"
							label="Sign In"
							primary={true}
							fullWidth={true}
						/>
						<div style={{ paddingTop: '5px' }}>
							<a
								href="#"
								style={styles.forgotPassword}
								onClick={this.gotoForgotPassword}
							>
								Forgot password?
							</a>
						</div>
					</form>
				)
			}
		}

		return (
			<div className="login-form-wrapper">
				<img src="/assets/images/logo.png" height="27" className="login-logo" />
				{renderScreen()}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {
		initRoom(id) {
			return initRoom(id);
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Login);
